const Accordion = () => {

    let headings = document.querySelectorAll('[data-question]');

    Array.from(headings).forEach(heading => {

        let target = heading.getAttribute('data-question');

        if (typeof target != "undefined" && target != null) {

            heading.addEventListener('click', () => {
            
                let content = document.querySelector(`[data-answer="${target}"]`);

                if (typeof content != "undefined" && content != null) {
                    heading.classList.toggle('open');
                    content.classList.toggle('open');
                }
            });
        }
    });
}

export default Accordion;